<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    type="list"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'drivers/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <tableSearch
      @search="search = $event"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('TITLE') + ' ' + $t('AND') + ' ' + $t('SERIALNUMBER'),
        })
      "
    />
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="
        tableData.results.filter(
          (data) =>
            !search ||
            data.title.includes(search) ||
            data.serial_number.includes(toEnglish(search))
        )
      "
      v-loading="loading"
      :stripe="true"
      :default-sort="{ prop: 'id', order: 'descending' }"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TITLE')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TITLE')">
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="vehicle"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="150"
      >
        <template slot-scope="scope">
          <LicensePlate
            :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate"
            :chars="alphaList"
          >
          </LicensePlate>
        </template>
      </el-table-column>

      <el-table-column
        prop="serial_number"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('SERIALNUMBER')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('SERIALNUMBER')">
            {{ numberWithSpaces(scope.row.serial_number) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="" width="170">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :description="scope.row.description"
              :router="{
                name: 'EDIT_FUEL',
                id: scope.row.id,
              }"
              @remove="remove($event)"
              :title="$t('FUEL_CARD')"
              @open="open($event)"
              @view="view($event, 'VIEW_FUEL')"
              :view="true"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { fuels, removeFuel } from '@/api/fuel'
import tableSearch from '@/components/elements/tableSearch'
import tableFeatures from '@/components/elements/tableFeatures'
import { licenseChars } from '@/api/global'
import LicensePlate from '@/components/cars/LicensePlate'
import { open } from '@/mixins/openDesc'
import { view } from '@/mixins/viewPage'
import { numberWithSpaces } from '@/mixins/numberWithSpaces'

export default {
  mixins: [open, view, numberWithSpaces],
  data() {
    return {
      tableData: {
        results: [],
      },
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],
      search: '',
      loading: true,
    }
  },

  methods: {
    sorttWork(a, b) {
      if (a.working < b.working) return -1
      if (a.working > b.working) return 1
      return 0
    },
    remove(id) {
      removeFuel.api(id).then((res) => {
        if (res) {
          this.$notify({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('DRIVER_TITLE'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.tableData.results = this.tableData.results.filter(
            (table) => table.id !== id
          )
        }
      })
    },
  },
  mounted() {
    fuels.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  components: {
    tableSearch,
    tableFeatures,
    LicensePlate,
  },
}
</script>
